module.exports = __webpack_public_path__ + "img/agent_login.8961248d.png";